module.exports = __webpack_public_path__ + "cf92b56d9f5603571bc5595984538960.MP3";